import React, {Component} from 'react';
import PropTypes from 'prop-types';

import ReorderableList from 'core/gd-ui/sortable-list-3/reorderable-list';
import ItemView from './item-row';
import ItemAdd from './item-add';


export default class ItemsListEditor extends Component {
    static propTypes = {
        items: PropTypes.array,
        incSeed: PropTypes.number,
        addLabel: PropTypes.string,

        colorSelectionEnabled: PropTypes.bool,

        onChange: PropTypes.func
    };

    static defaultProps = {
        items: [],
        colorSelectionEnabled: false
    };

    constructor(props, context) {
        super(props, context);


        let initialItems = props.items;

        if (!initialItems || initialItems.length === 0) {

            initialItems = [];

            initialItems.push({
                value: this.generateId(initialItems), label: "Option 1", sortPosition: 1
            })
            initialItems.push({
                value: this.generateId(initialItems), label: "Option 2", sortPosition: 2
            })

            // set form field value if not set yet
            this.onChange(initialItems);
        }

        this.state = {
            items: initialItems
        };
    }

    generateId = (options=null) => {
        if (_.isNil(options)) options = this.state.items;
        const existingIds = _.map(options, item=>item.value);
        return gd.utils.generateUIDWithCollisionChecking(existingIds);
    }

    onChange = (items) => {
        if (this.props.onChange) this.props.onChange(items);
    };

    onAddItem = () => {

        const items = _.cloneDeep(this.state.items);

        items.push({
            value:this.generateId(),
            label:"",
            sortPosition: 0
        });

        this.setState({items:items},()=>{
            this.onChange(items);
            if (this.lastItemView) this.lastItemView.focus()
        });
    };

    onDragEnd = (items) => {
        items.map((i,key)=>{i.sortPosition = key;});
        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    }

    onDeleteItem = (item) => {
        let items = _.cloneDeep(this.state.items);
        const index = items.indexOf(_.find(items, i=>i.value === item.value));
        if (index !== -1) items.splice(index,1);

        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };

    onItemRename = (id, label) => {
        const items = _.cloneDeep(this.state.items);
        const item = _.find(items, i=>i.value === id);
        item.label = label;
        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };

    onItemChangeColor = (id, color) => {
        const items = _.cloneDeep(this.state.items);
        const item = _.find(items, i=>i.value === id);
        item.color = color;

        this.setState({items:items},()=>{this.onChange(items, this.state.incSeed)});
    };


    render() {
        const classes = Classes("options-list", this.props.className);

        const lastItemKey = this.state.items.length - 1;
        const components = this.state.items.map((item, key)=>({
            item: item,
            component: <ItemView key={key}
                                 ref={r=>{if (lastItemKey === key) this.lastItemView = r}}
                                 item={item}
                                 colorSelectionEnabled={this.props.colorSelectionEnabled}
                                 onItemRename={this.onItemRename}
                                 onItemChangeColor={this.onItemChangeColor}
                                 onDeleteClick={this.state.items.length > 1 ? this.onDeleteItem : null}/>
        }));

        return (
            <div className="items-list-editor">
                <ReorderableList className={classes}
                                 items={components}
                                 onDragEnd={this.onDragEnd}
                                 dragSourceType="reorderableOptionsList"/>

                <ItemAdd label={this.props.addLabel} onClick={this.onAddItem}/>
            </div>
        )
    }
}
